import { render, staticRenderFns } from "./organisationRegistrationTesting.vue?vue&type=template&id=18129aad"
import script from "./organisationRegistrationTesting.vue?vue&type=script&lang=ts"
export * from "./organisationRegistrationTesting.vue?vue&type=script&lang=ts"
import style0 from "./organisationRegistrationTesting.vue?vue&type=style&index=0&id=18129aad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports